import React, { useState } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import {
  LinkedGroupedMultiSelectGroupedItem,
  LinkedGroupedMultiSelectItem,
} from '@/type';
import LinkedGroupedMultiSelectInput from '@components/common/input/LinkedGroupedMultiSelectInput';

interface LinkedGroupedMultiSelectProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  name: string;
  items: LinkedGroupedMultiSelectItem[];
  groupedItems: LinkedGroupedMultiSelectGroupedItem[];
  itemLabel: string;
  groupLabel: string;
  defaultGroupItemIds?: string[];
  defaultItemIds?: string[];
}

const LinkedGroupedMultiSelectController = <
  TFieldValues extends FieldValues = FieldValues,
>({
  control,
  name,
  items,
  groupedItems,
  itemLabel,
  groupLabel,
  defaultGroupItemIds = [],
  defaultItemIds = [],
}: LinkedGroupedMultiSelectProps<TFieldValues>) => {
  return (
    <Controller
      control={control}
      name={name as Path<TFieldValues>}
      render={({ field }) => {
        //TODO: use field.value as a default value, but doesnt work as expected
        const [selectedItemIds, setSelectedItemIds] = useState<string[]>(defaultItemIds);
        const [selectedGroupIds, setSelectedGroupIds] =
          useState<string[]>(defaultGroupItemIds);

        return (
          <LinkedGroupedMultiSelectInput
            name={name}
            items={items}
            groupedItems={groupedItems}
            itemLabel={itemLabel}
            groupLabel={groupLabel}
            selectedItemIds={selectedItemIds}
            setSelectedItemIds={(ids) => {
              setSelectedItemIds(ids);
              field.onChange(ids);
            }}
            selectedGroupIds={selectedGroupIds}
            setSelectedGroupIds={(ids) => {
              setSelectedGroupIds(ids);
            }}
          />
        );
      }}
    />
  );
};

export default LinkedGroupedMultiSelectController;
